import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { Box, Button, Input, Select, VStack, Heading, Text, useToast } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

const Signup = () => {
  
const { signupWithEmail } = useAuth();
  const navigate = useNavigate();
  const toast = useToast();
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [howDidYouHear, setHowDidYouHear] = useState("");
  const [otherSource, setOtherSource] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    if (password !== confirmPassword) {
      toast({
        title: t("passwordMismatch"),
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      setLoading(false);
      return;
    }

    try {
      const source = howDidYouHear === "other" ? otherSource : howDidYouHear;
      await signupWithEmail(email, password, companyName, source);
      toast({
        title: t("accountCreated"),
        status: "success",
        duration: 3000,
        isClosable: true,
      });
      navigate("/dashboard");
    } catch (error: unknown) {
      let errorMessage = t("unexpectedError");
      if (error instanceof Error) {
        errorMessage = error.message;
      }
      toast({
        title: t("failedToCreateAccount"),
        description: errorMessage,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box maxWidth="400px" margin="auto" mt={8}>
      <Heading as="h1" size="xl" textAlign="center" mb={6}>
        {t("signUp")}
      </Heading>
      <form onSubmit={handleSubmit}>
        <VStack spacing={4}>
          <Input
            type="email"
            placeholder={t("email")}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <Input
            type="password"
            placeholder={t("password")}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <Input
            type="password"
            placeholder={t("confirmPassword")}
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
          />
          <Input
            placeholder={t("companyName")}
            value={companyName}
            onChange={(e) => setCompanyName(e.target.value)}
            required
          />
          <Select
            placeholder={t("howDidYouHear")}
            value={howDidYouHear}
            onChange={(e) => setHowDidYouHear(e.target.value)}
            required
          >
            <option value="search">{t("searchEngine")}</option>
            <option value="social">{t("socialMedia")}</option>
            <option value="friend">{t("friendRecommendation")}</option>
            <option value="other">{t("other")}</option>
          </Select>
          {howDidYouHear === "other" && (
            <Input
              placeholder={t("pleaseSpecify")}
              value={otherSource}
              onChange={(e) => setOtherSource(e.target.value)}
              required
            />
          )}
          <Button type="submit" colorScheme="primary" isLoading={loading} width="100%">
            {t("signUp")}
          </Button>
        </VStack>
      </form>
      <Text mt={4} textAlign="center">
        {t("alreadyHaveAccount")} <Button variant="link" onClick={() => navigate("/login")}>{t("login")}</Button>
      </Text>
    </Box>
  );
};

export default Signup;
